<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="400">
			<v-card>
				<v-form ref="formChangePassword" role="form" v-on:submit.prevent="simpan">
					<v-card-title class="text-h6" >Ubah Kata Sandi Pengguna</v-card-title>
					<v-card-text>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-row>
									<v-col cols="12" sm="12" md="12" class="pb-0">
										<v-text-field outlined dense @focus="() => responseError.password_old=''" :error-messages="responseError.password_old" :rules="[inputrules.required]" v-model="oldpassword" :type="typeInput0" :append-icon="icon0" @click:append="showPassword0" label="Kata Sandi Lama"></v-text-field>
									</v-col>
									<v-col cols="12" sm="12" md="12" class="pb-0">
										<v-text-field outlined dense @focus="() => responseError.password_new=''" :error-messages="responseError.password_new" :rules="[inputrules.required, inputrules.password]" v-model="password" :type="typeInput" :append-icon="icon" @click:append="showPassword" label="Kata Sandi Baru"></v-text-field>
									</v-col>
									<v-col cols="12" sm="12" md="12" class="pb-0">
										<v-text-field outlined dense @focus="() => alertRepassword=''" :error-messages="alertRepassword" v-model="repassword" :type="typeInput2" :rules="[inputrules.required]" :append-icon="icon2" @click:append="showRepassword" label="Ulangi Kata Sandi"></v-text-field>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="grey darken-1" outlined @click="hide">Batal</v-btn>
						<v-btn color="cyan darken-2" depressed type="submit">Simpan</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
	data () {
		return {
			dialog: false,
			oldpassword: '',
			password: '',
			repassword: '',
			alertRepassword: '',
			typeInput0: 'password',
			icon0: 'mdi-eye',
			typeInput: 'password',
			icon: 'mdi-eye',
			typeInput2: 'password',
			icon2: 'mdi-eye',
		}
	},
	props: {
		selectedUser: String,
		filter: Object,
		type: String,
	},
	computed: {
		...mapState('userSupplier', ['responseError']),
	},
	methods: {
		show(){
			this.dialog = true
		},
		hide() {
			this.$refs.formChangePassword.reset()
			this.dialog = false
		},
		showPassword0() {
			this.typeInput0 = this.typeInput0 == 'text' ? 'password' : 'text'
			this.icon0 = this.icon0 == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		showPassword() {
			this.typeInput = this.typeInput == 'text' ? 'password' : 'text'
			this.icon = this.icon == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		showRepassword() {
			this.typeInput2 = this.typeInput2 == 'text' ? 'password' : 'text'
			this.icon2 = this.icon2 == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		simpan() {
			if (this.password !== this.repassword) {
				this.alertRepassword = "Password tidak sama"
			} else {
				this.alertRepassword = ''
				if (this.$refs.formChangePassword.validate()) {
					let params = {
						password_old: this.oldpassword,
						password_new: this.password
					}
					this.$emit('action', params)
				}
			}
		},
	}
}
</script>
